import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { showAlert as showAlertAction } from 'src/redux/Components/Alert/AlertSlice'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

type Severity = 'success' | 'error' | 'warning'

export const useAlert = () => {
    const dispatch = useDispatch()
    const showAlert = useCallback((severity: Severity, message: string) => {
        if (severity === 'success' && process.env.REACT_APP_ENV === 'QA') {
            return
        }
        dispatch(showAlertAction({ severity, message }))
        toast[severity](message) // Utilizamos react-toastify para mostrar la alerta.
    }, [dispatch])

    return { showAlert }
}
